module.exports = __webpack_public_path__ + "static/img/side-advertisement-3.1ed94cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/side-advertisement-3.png
// module id = 4fPr
// module chunks = 1